import cx from "classnames";
import { ListItem } from "@/components/__shared__/ListItem/ListItem";
import styles from "./SideDrawerListItem.module.scss";

type Props = React.ComponentProps<typeof ListItem>;

/**
 * ListItem as used by the product side drawer triggers.
 *
 * Renders ListItem unchanged apart from an extra class, which lets the drawers
 * restyle the label under the useNewTypography experiment. Deliberately adds no
 * DOM element of its own: ListItem.module.scss and Standard.module.scss collapse
 * borders and margins with adjacent sibling selectors between the buttons.
 */
export const SideDrawerListItem = ({ className, ...props }: Props) => (
  <ListItem {...props} className={cx(styles.sideDrawerListItem, className)} />
);
